"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyHoldInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsHold_1 = require("../../model/hsHold");
var service_1 = require("../../../library/base/service");
var MyHoldInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyHoldInfo, _super);
    function MyHoldInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的持仓接口';
        _this.code = '105007';
        _this.desc = '我的持仓接口';
        _this.requestParams = new hsHold_1.MyHoldInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyHoldInfo;
}(service_1.BaseService));
exports.MyHoldInfo = MyHoldInfo;
//# sourceMappingURL=myHoldInfo.js.map